export const profile = {
  name: "Tharindu D Rajapaksha",
  shortName: "Tharindu",
  tagline: "PhD Candidate | Diffractive Optics | Photonics devices",
  avatar: "/me.png",
  social: {
    linkedin: "https://linkedin.com/in/tharindudamesha",
    scholar: "https://scholar.google.com/citations?user=XDW05nYAAAAJ",
    instagram: "https://www.instagram.com/im_tharindu/",
  },
};

export const education = [
  { degree: "PhD in Physics", school: "Virginia Tech", years: "2021–Present" },
  { degree: "Master's in Physics", school: "Virginia Tech", years: "2021–2024" },
  { degree: "B.Sc. (Honors) in Physics", school: "University of Peradeniya", years: "2016–2020" },
];

export const skills = [
  "Nanofabrication",
  "Diffractive Optics",
  "Photonic Devices",
  "FDTD / Meep Simulation",
  "Lumerical",
  "Metasurfaces Design",
  "Python",
  "Blender 3D Modeling",
  "Scientific Writing",
  "Project Management",
  "Teamwork",
  "Problem Solving",
];

export const projects = [
  {
    title: "SPECIES",
    image: "/sat.png",
    link: "https://ieeexplore.ieee.org/abstract/document/11313999",
    description:
      "Smart Polyimide Expandable Collector to enable Investigations for Earth Science. Deployable membrane-based CubeSat payload.",
  },
  {
    title: "Diffractive Optics",
    image: "/PS1.png",
    link: "https://advanced.onlinelibrary.wiley.com/doi/full/10.1002/adom.202400847",
    description:
      "Design and fabrication of photon sieves and multi-level Fresnel zone plates using UV lithography.",
  },
  {
    title: "Metalenses",
    image: "/metas.png",
    link: "https://en.wikipedia.org/wiki/Electromagnetic_metasurface",
    description:
      "Design of metasurface metalenses using phase–radius libraries, hexagonal and circular unit cells, and GDSII generation.",
  },
  {
    title: "Graphene FET Biosensors",
    image: "/bio.png",
    link: "https://advanced.onlinelibrary.wiley.com/doi/10.1002/aelm.202400716",
    description:
      "Fabrication of back-gated graphene field-effect transistors (GFETs) with Au contacts and SiO₂ dielectric.",
  },
  {
    title: "GFET Photodetectors",
    image: "/sensor.png",
    link: "https://pubs.acs.org/doi/10.1021/acsaelm.4c02268",
    description:
      "High-mobility graphene transistors designed for ultra-sensitive broadband light detection.",
  },
  {
    title: "Electromagnetic Simulations",
    image: "/simulation.png",
    link: "https://opg.optica.org/oe/abstract.cfm?doi=10.1364/OE.581470",
    description:
      "RCWA, FDTD, and Meep simulations of metasurfaces, Fresnel zone plates, and photonic devices.",
  },
];

export const patents = [
  {
    title: "Mold-Based Diffractive Optics",
    inventors:
      "John P Leckey, Vinh Nquyen, Leslie Howe, Tharindu Rajapaksha, Scott M Bartram, David G MacDonnell",
    number: "US20260102982A1",
    year: "2026",
    status: "pending",
    url: "https://patents.google.com/patent/US20260102982A1/en",
  },
];

export const galleryWork = [
  { src: "/assets/IMG_0913.jpg", title: "NASA LaRC", category: "work" },
  { src: "/4.png", title: "VT", category: "photography" },
  { src: "/assets/IMG_0979.jpg", title: "NASA LaRC", category: "work" },
  { src: "/assets/IMG_2013.jpg", title: "NASA LaRC", category: "photography" },
  { src: "/5.png", title: "Micron @VT", category: "photography" },
  { src: "/assets/IMG_2125.jpg", title: "NASA LaRC", category: "photography" },
];

export const galleryRenders = [
  { src: "/mold11.png", title: "Mold Design" },
  { src: "/peeloff.png", title: "Membrane Releasing" },
  { src: "/PS1.png", title: "Photon Sieve Design" },
  { src: "/final.png", title: "Optical Characterization Setup" },
  { src: "/etch3.png", title: "Reactive Ion Etch" },
  { src: "/bio.png", title: "GFET Bio Sensor" },
];

export const galleryPhotos = [
  "/assets/IMG_2606.jpg",
  "/assets/IMG_2751.jpg",
  "/assets/IMG_3141.jpg",
  "/assets/IMG_6321.jpg",
  "/assets/IMG_8112.jpg",
  "/assets/IMG_8213.jpg",
  "/assets/IMG_8676.jpg",
];

export const navLinks = [
  { href: "#skills", label: "Skills" },
  { href: "#projects", label: "Projects" },
  { href: "#patents", label: "Patents" },
  { href: "#publications", label: "Publications" },
  { href: "#gallery", label: "Gallery" },
];
